<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
     v-dialogDrag
    :visible.sync="visible">
    <el-button v-if="method != 'add'" size="medium" class="mb8" icon="el-icon-edit" type="warning"  @click="handEditorView(method)" :disabled="!hasPermission('cecunmsetmeal:cecUnmSetMeal:edit')">编辑</el-button>
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row  :gutter="15">
        <el-col :span="24">
          <el-form-item label="封面" prop="pic"
                :rules="[
                  {required: true, message:'封面不能为空', trigger:'blur'}
                 ]">
                 <CropperView ref="cropperviewRef" 
                 :imgSrc="inputForm.pic" 
                 :autoCropWidth="335"
                 :autoCropHeight="420" 
                 :disabled="method === 'view'"  
                 :actionButtonFlag="true" 
                 :objectFit="'cover'" 
                 :listIndex="1" 
                 @updateChange="changeImage($event,inputForm)">
                 </CropperView>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="英文名称" prop="nameEn"
                :rules="[
                  {required: true, message:'英文名称不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.nameEn" placeholder="请填写英文名称"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="中文名称" prop="nameCn"
                :rules="[
                 ]">
              <el-input v-model="inputForm.nameCn" placeholder="请填写中文名称"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="预估价格" prop="targetPrice"
                :rules="[
                  {required: true, message:'预估价格不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.targetPrice" placeholder="请填写" @input="handleInput($event,'targetPrice')"  @focus="focusInput($event,'targetPrice')" @blur="blurInput($event,'targetPrice')" ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="关联套餐" prop="setsId"
                :rules="[
                  {required: true, message:'关联套餐不能为空', trigger:'blur'}
                 ]">
              <!-- <el-input v-model="inputForm.setsId" placeholder="请填写父级套餐id"     ></el-input> -->
              <el-select v-model="inputForm.setsId" filterable placeholder="请选择关联套餐" style="width: 100%;">
                  <el-option
                    v-for="item in dataList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="排序" prop="sort"
                :rules="[
                  {required: true, message:'排序不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.sort" placeholder="请填写排序"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="状态" prop="state"
                :rules="[
                  {required: true, message:'状态不能为空', trigger:'blur'}
                 ]">
                <el-select v-model="inputForm.state" placeholder="请选择"  style="width: 100%;">
                          <el-option
                            v-for="item in stateOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                      </el-select>
           </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="类型" prop="type"
                :rules="[
                  {required: true, message:'类型不能为空', trigger:'blur'}
                 ]">
                <el-select v-model="inputForm.type" placeholder="请选择"  style="width: 100%;">
                          <el-option
                            v-for="item in $dictUtils.getDictList('sets_type')"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                      </el-select>
           </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="标签" prop=""
            :rules="[
              ]">
              <tagSelect ref="tagSelectRef" :value="inputForm.tagsIds" @searchChange="handSelect" @addTagCloud="addTagCloud" associationType="3"></tagSelect>
            </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
            <el-form-item label="项目数量" prop="num"
                :rules="[
                 ]">
              <el-input v-model="inputForm.num" placeholder="请填写项目数量"     ></el-input>
           </el-form-item>
        </el-col> -->
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">关闭</el-button>
      <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import cecUnmSetMealService from '@/api/cecunmsetmeal/cecUnmSetMealService'
  import cecUnmSetsService from '@/api/unmsets/cecUnmSetsService'
  import CropperView from '@/components/upload/ImageUploadCropper.vue'
  import tagSelect from '@/components/select/tagSelect'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          nameEn: '',
          nameCn: '',
          setsId: '',
          sort: '',
          type: '',
          num: '',
          pic: '',
          tagsIds: '',
          coverImage: {
            filePath: '',
            category: '',
            id: ''
          },
          state: '',
          targetPrice: ''
        },
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 100,
          orders: [{ column: 'sort', asc: false }]
        },
        dataList: [],
        stateOption: [
          { value: '0', label: '上线' },
          { value: '2', label: '草稿' },
          { value: '1', label: '下线' }
        ]
      }
    },
    components: {
      CropperView,
      tagSelect
    },
    methods: {
      /** 输入框变化 */
      handleInput (value, type) {
        if (value === '') return
        const regex = /^\d+(\.\d*)?$/ // 使用正则表达式匹配 正整数 或小数点位数不限制的浮点数
        let formattedValue = value
        // 如果输入值不符合正则表达式，则将其设置为上一个有效值
        if (!regex.test(value)) {
          formattedValue = value.replace(/,/g, '').replace(/\D/g, '')
          // this.inputForm[type] = value.slice(0, value.length - 1)
          // this.handleInput(this.inputForm[type], type)
        }
        this.inputForm[type] = formattedValue
      },
      /** 输入框获得焦点 */
      focusInput (e, type) {
        if (e) return
        const val = e
        this.inputForm[type] = this.moneyToNumber(val) // 千分位转数值
      },
      /** 输入框失去焦点 */
      blurInput (e, type) {
        let val = e.target.value
        val = !val ? '' : Number(val)
        this.inputForm[type] = this.formateMoney(val) // 数值转为千分位格式
      },
      handSelect (e) {
        this.inputForm.tagsIds = e ? e.join(',') : ''
      },
      formateMoney (number) {
        return number.toLocaleString('zh-CN')
      },
      moneyToNumber (str) {
        // 使用正则表达式去除千分位分隔符（逗号）
        const cleanStr = str.replace(/,/g, '')
        // 将清理后的字符串转换为数值类型
        const number = parseFloat(cleanStr)
        return number
      },
      //  upload image 上传图片
      changeImage (e, item) {
        if (e) {
          item.pic = typeof e === 'string' ? e : e.filePath
          item.coverImage = {
            category: 'setsCover',
            filePath: typeof e === 'string' ? e : e.filePath
          }
          // this.saveData(item)
        } else {
          item.pic = ''
        }
      },
      // 切换编辑状态
      handEditorView (method) {
        this.method = method === 'view' ? 'edit' : 'view'
      },
      init (method, id) {
        this.refreshList()
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建UM套餐表`
        } else if (method === 'edit') {
          this.title = '修改UM套餐表'
        } else if (method === 'view') {
          this.title = '查看UM套餐表'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.clearForm()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecUnmSetMealService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              if (data.coverImage) {
                this.inputForm.pic = data.coverImage.filePath
              }
              this.loading = false
            })
          }
        })
      },
      clearForm () {
        this.inputForm.pic = ''
        this.inputForm.tagsIds = ''
        this.$refs.tagSelectRef.getTagCloud()
        this.$refs.cropperviewRef.resetFields()
        this.$refs.inputForm.resetFields()
      },
      refreshList () {
        this.loading = true
        cecUnmSetsService.list({
          'current': this.tablePage.currentPage,
          'size': this.tablePage.pageSize,
          'orders': this.tablePage.orders
        }).then(({data}) => {
          let setList = data.records.map(item => {
            let query = {
              value: item.id,
              label: item.nameCn
            }
            return query
          })
          this.dataList = setList
        })
      },
      // 表单提交
      doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecUnmSetMealService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      },
      addTagCloud () {
        this.$emit('addTagCloud')
      }
    }
  }
</script>

  
